import { z } from 'zod';

/**
 * 待建卡（proposed）与审批入池的对外契约。
 *
 * 页签的「缺什么」是**必填**，不是可选：待建卡的每个空页签都得说清缺什么、由谁补。
 * 若这里允许省略，前端就会收到一个合法但什么都没说的页签，
 * 渲染出来是一片空白——而空白说不清是「本来没内容」还是「没加载出来」（P-13）。
 */

export const buildGapSchema = z.object({
  title: z.string(),
  detail: z.string(),
  /** 这条待办卡住哪一级状态。 */
  blocks: z.string(),
  /** 由哪张建设 ATC 来做。null 表示尚未指派——**不是「没人管」**，是还没指派。 */
  builder: z.string().nullable(),
  status: z.string(),
});

export const tabStateSchema = z.object({
  key: z.enum([
    'card', 'registration', 'definition', 'sop',
    'people', 'data', 'ledger', 'blueprint',
  ]),
  label: z.string(),
  present: z.array(z.object({ label: z.string(), value: z.string() })),
  gaps: z.array(buildGapSchema),
  note: z.string(),
});

export const proposedCardSchema = z.object({
  code: z.string(),
  name: z.string(),
  status: z.string(),
  determinism: z.string(),
  hotlGate: z.boolean(),
  proposalSummary: z.string().nullable(),
  positionName: z.string(),
  departmentName: z.string(),
  effectiveFrom: z.string(),
  approval: z
    .object({
      approvedBy: z.string(),
      approvedAt: z.string(),
      artifactId: z.string(),
      candidateIndex: z.number(),
    })
    .nullable(),
  todoTotal: z.number(),
  todoPending: z.number(),
  tabs: z.array(tabStateSchema),
});

export const poolCardListSchema = z.object({
  cards: z.array(
    z.object({
      code: z.string(),
      name: z.string(),
      status: z.string(),
      determinism: z.string(),
      positionName: z.string(),
      todoPending: z.number(),
    }),
  ),
});

export type BuildGap = z.infer<typeof buildGapSchema>;
export type TabState = z.infer<typeof tabStateSchema>;
export type ProposedCard = z.infer<typeof proposedCardSchema>;
export type PoolCardList = z.infer<typeof poolCardListSchema>;
export type PoolCardSummary = PoolCardList['cards'][number];
